import { CommonsSessionStorageService } from 'ib-web-commons/dist/utils';

import angular from 'angular';
import { DatalayerBKIConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/constants/ib-datalayer-bki-constants';
import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';
import { AncillariesService } from '../../../components/ib-web-ancillaries/ib-web-ancillaries-service';
import { AncillariesUtilsService } from '../../../../shared/ib-web-ancillaries-utils';
import { ModalServiceAncillaries } from '../../ib-modal/services/ib-modal-ancillaries-service';
import { SeatsMapService } from '../service/ib-seat-map-service';
import { SeatsMapTransformer } from '../transformer/ib-seat-map-transformer';
const controllerInfo = {
    module: 'ib-seat-map-module',
    inject: ['$rootScope', '$uibModalInstance', '$window', 'AncillariesService', 'SeatsMapService', 'object', '$scope', '$timeout', 'AncillariesConstants', 'CurrencyService', 'localStorageService', 'AncillariesUtilsService', '$location', 'ModalServiceAncillaries', 'SeatsMapTransformer', 'DatalayerUtilsService', 'CommonsConstants', 'DatalayerConstants', 'DatalayerUtils', 'DatalayerBKIConstants', 'CommonsSessionStorageService', 'CommonsUtilService'],
    required: []
};

export class SeatsMapController implements ng.IController {
    public model;
    public isLoading = true;
    public keyDown = false;
    public currency: any;
    public updateData;
    public backPassengerUpdate = false;
    public showModalAvios: boolean = false;
    public flightAviosInfo: boolean;
    public reductedMovilityBanner: boolean;
    public isSummaryMobile: boolean = true;
    public showTour: boolean = false;

    constructor (
        private $rootScope: CommonsRootScope,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private $window: ng.IWindowService,
        private AncillariesService: AncillariesService,
        private SeatsMapService: SeatsMapService,
        private object: any,
        private $scope: angular.IScope,
        private $timeout: ng.ITimeoutService,
        private AncillariesConstants: AncillariesConstant,
        private CurrencyService: CurrencyService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private AncillariesUtilsService: AncillariesUtilsService,
        private $location: ng.ILocationService,
        private ModalServiceAncillaries: ModalServiceAncillaries,
        private SeatsMapTransformer: SeatsMapTransformer,
        private DatalayerUtilsService: DatalayerUtilsService,
        private CommonsConstants: CommonsConstantsType,
        private DatalayerConstants: DatalayerConstantsType,
        private DatalayerUtils: DatalayerUtils,
        private DatalayerBKIConstants: DatalayerBKIConstantsType,
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private CommonsUtilService: CommonsUtilService) {
        this.model = this.object;
        this.$scope.$on('previousPassenger', this.previousPassenger);
        this.$scope.$on('nextPassenger', this.nextPassenger);
        this.$scope.$on('nextFlight', this.nextFlight);
        this.$scope.$on('previousFlight', this.previousFlight);
        this.$scope.$on('backPassenger', this.backPassenger);
        this.$scope.$on('seatChange', this.updatePassengerSeat);
        this.$scope.$on('selectScrollPassenger', this.selectScrollPassenger);
        this.flightAviosInfo = this.AncillariesUtilsService.validatedFlightAviosInfo();
    }

    $onInit (): void {
        this.activate();
    }

    activate = (): void => {
        this.SeatsMapService.searchSeatsMap().then((data) => {
            const upgradeInfo: any = this.localStorageService.get('upgradeInfo');
            if (upgradeInfo) {
                for (let i = 0; i < upgradeInfo.offers.length; i++) {
                    for (let j = 0; j < upgradeInfo.offers[i].offerSegmentClasses.length; j++) {
                        if (upgradeInfo.offers[i].offerSegmentClasses[j].segment === data.segmentInfo.id) {
                            data.segmentInfo.cabinClassType =
                                upgradeInfo.offers[i].offerSegmentClasses[j].cabinClass.type;
                            switch (data.segmentInfo.cabinClassType) {
                                    case 'ECONOMY':
                                        data.segmentInfo.cabinClass = 'CABIN_TOURIST';
                                        break;
                                    case 'BUSINESS':
                                        data.segmentInfo.cabinClass = 'CABIN_BUSINESS';
                                        break;
                                    case 'BUSINESS_PLUS':
                                        data.segmentInfo.cabinClass = 'CABIN_BUSINESS';
                                        break;
                                    case 'BUSINESS_CLUB':
                                        data.segmentInfo.cabinClass = 'CABIN_BUSINESS';
                                        break;
                                    case 'BUSINESS_CLASS':
                                        data.segmentInfo.cabinClass = 'CABIN_BUSINESS';
                                        break;
                                    case 'PREMIUMTOURIST':
                                        data.segmentInfo.cabinClass = 'CABIN_PREMIUM_TOURIST';
                                        break;
                                    default:
                                        data.segmentInfo.cabinClass = 'CABIN_TOURIST';
                                        break;
                            }
                        }
                    }
                }
            }
            const upgradedSegments: any = this.localStorageService.get('upgradingAcceptedSegments');
            if (upgradedSegments && upgradedSegments.code === 200) {
                for (let i = 0; i < upgradedSegments.data.acceptedSegments.length; i++) {
                    if (upgradedSegments.data.acceptedSegments[i].id === data.segmentInfo.id) {
                        for (let j = 0; j < upgradedSegments.data.acceptedSegments[i].passengers.length; j++) {
                            for (let k = 0; k < data.passengersInfo.length; k++) {
                                if (
                                    upgradedSegments.data.acceptedSegments[i].passengers[j].id ===
                                    data.passengersInfo[k].id
                                ) {
                                    data.passengersInfo[k].currentSeat.column =
                                        upgradedSegments.data.acceptedSegments[i].passengers[j].seat.column;
                                    data.passengersInfo[k].currentSeat.row =
                                        upgradedSegments.data.acceptedSegments[i].passengers[j].seat.row;
                                    data.passengersInfo[k].initialSeat.column =
                                        upgradedSegments.data.acceptedSegments[i].passengers[j].seat.column;
                                    data.passengersInfo[k].initialSeat.row =
                                        upgradedSegments.data.acceptedSegments[i].passengers[j].seat.row;
                                }
                            }
                        }
                    }
                }
            }
            this.model.seatMapInfo.segmentInfo = data.segmentInfo;
            this.model.seatMapInfo.columnsInfo = data.columnsInfo;
            this.model.seatMapInfo.passengersInfo = data.passengersInfo;
            this.model.seatMapInfo.currentPassengerIndex = data.currentPassengerIndex;
            this.model.seatMapInfo.flightMap = data.flightMap;
            this.model.seatMapInfo.legendInformation = data.legend;
            this.model.seatMapInfo.totalPrice = data.totalPrice;
            this.model.seatMapInfo.currency = data.currency;
            this.model.isFirstSegment = data.isFirstSegment;
            this.model.isLastSegment = data.isLastSegment;
            this.model.pricesProvider = data.pricesProvider;
            this.model.seatGeneralInfo = this.localStorageService.get('genAviosAncillariesSeat') || [];
            this.model.isCurrencyLong = this.AncillariesUtilsService.isCurrencyLong(this.model.seatMapInfo.currency.code);
            this.localStorageService.set('addEarlyChecking', this.AncillariesUtilsService.addEarlyChecking(data, this.localStorageService.get('addEarlyChecking')));
            this.currency = data.currency;
            this.updateData = [];
            if (this.CommonsSessionStorageService.get('newSeatsMap')) {
                this.model.seatMapInformation = this.CommonsSessionStorageService.get('seatMap');
                this.model.orderData = this.CommonsSessionStorageService.get('createOrderData');
                const availableCabins: Array<string> =['ECONOMY', 'PREMIUMTOURIST', 'BUSINESS'];
                const validAircrafts: Array<string> = ['359', '320', '32A'];
                let tourAvailable: boolean = true;
                let cabinToShow;
                let aircraftToShow = null;
                angular.forEach(this.model.seatMapInformation.cabins, (cabin) => {
                    if (availableCabins.includes(cabin.cabinClass.type) && cabin.enabled) {
                        tourAvailable = true;
                        cabinToShow = cabin.cabinClass.type;
                    }
                });
                let aircraftIsValid = true;
                if(this.model.orderData) {
                    this.model.orderData.order.slices.forEach((slice) => {
                        if (slice.segments) {
                            slice.segments.forEach((segment) => {
                                if (!validAircrafts.includes(segment.flight.aircraft.code)) {
                                    aircraftIsValid = false;
                                }
                                if(aircraftToShow === null) {
                                    aircraftToShow = segment.flight.aircraft.code;
                                }
                            });
                        }
                    });
                } else if(this.CommonsSessionStorageService.get('bookingInfo')) {
                    const bkiInfo: any = this.CommonsSessionStorageService.get('bookingInfo');
                    if(bkiInfo !== null && bkiInfo !== undefined) {
                        if(bkiInfo.order && bkiInfo.order.slices) {
                            bkiInfo.order.slices.forEach((slice) => {
                                slice.segments.forEach(segment => {
                                    if(!validAircrafts.includes(segment.flight.aircraft.code)) {
                                        aircraftIsValid = false;
                                    }
                                    if(aircraftToShow === null) {
                                        aircraftToShow = segment.flight.aircraft.code;
                                    }
                                });
                            });
                        } else {
                            if(bkiInfo.outwardSegments) {
                                bkiInfo.outwardSegments.forEach((segment) => {
                                    if(!validAircrafts.includes(segment.aircraft.model)) {
                                        aircraftIsValid = false;
                                    }
                                    if(aircraftToShow === null) {
                                        aircraftToShow = segment.aircraft.model;
                                    }
                                });
                                bkiInfo.returnSegments.forEach((segment) => {
                                    if(!validAircrafts.includes(segment.aircraft.model)) {
                                        aircraftIsValid = false;
                                    }
                                });
                            }
                        }
                    } else {
                        aircraftIsValid = false;
                    }
                }
                if(tourAvailable && aircraftIsValid) {
                    this.$window.SeatMapVr.config({
                        resource_cdn: 'https://iberia.3dseatmapvr.com',
                        destinationSelector: '.seatmap3Dview'
                    });
                    this.$window.SeatMapVr.init();
                    this.$window.SeatMapVr.selectScene({
                        layout: aircraftToShow,
                        scene: cabinToShow,
                        thumbnailMode: true,
                        mode : 0
                    });
                    this.showTour = true;
                    this.$scope.$apply();
                }
                angular.forEach(this.model.seatMapInfo.legendInformation, (legendInfo) => {
                    legendInfo.icon = 'xl';
                });
            }
            this.$timeout(() => {
                const dynamicPricingSeat: string = (this.model?.pricesProvider === 'IBDP') ? this.DatalayerConstants.DATALAYER_VALUES.YES : this.DatalayerConstants.DATALAYER_VALUES.NO;
                /* INIT DELETE GA4 MIGRATION */
                const confirmationDatalayerInfo = this.localStorageService.get('confirmationDatalayerInfo') || {};

                confirmationDatalayerInfo[this.DatalayerConstants.DATALAYER_INFO.DYNAMIC_PRICING_SEAT] = dynamicPricingSeat;
                this.DatalayerUtilsService.updateDatalayerWithQuadrigam(this.CommonsConstants.QUADRIGAM.MODAL_SELECT_SEAT, confirmationDatalayerInfo, this.localStorageService.get('userLogged'));
                this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);

                /* FINISH DELETE GA4 MIGRATION*/
                const confirmationDigitalInfo = this.localStorageService.get('confirmationDigitalInfo') || {};
                confirmationDigitalInfo[this.DatalayerBKIConstants.DYNAMIC_PRICING_SEAT] = dynamicPricingSeat;
                this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(this.CommonsConstants.QUADRIGAM.MODAL_SELECT_SEAT, confirmationDigitalInfo, this.localStorageService.get('userLogged'));
                this.DatalayerUtilsService.updateDatalayerViewEvent();
                this.DatalayerUtils.getAncillariesDigitalDataEcommerce('seat', this.DatalayerConstants.EVENTS_ECOMMERCE.VIEW_ITEM_LIST);
                this.AncillariesUtilsService.isBookingFlow() ? this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), null, this.CommonsConstants.QUADRIGAM.MODAL_SELECT_SEAT) :this.DatalayerUtilsService.setProcessAndStep(this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES, null, this.CommonsConstants.QUADRIGAM.MODAL_SELECT_SEAT);
                this.$scope.$broadcast('scrollToSeat');
                this.$scope.$broadcast('reloadInitialStatus');
                this.isLoading = false;
                this.model.isLoaded = true;
            });
        });
        if (this.localStorageService.get('deepLinkData')) {
            this.updateDalayerInfo(this.AncillariesConstants.QUADRIGAM.MODAL_SELECT_SEAT_DEEPLINK);
        }
        // show modal avios
        this.model.seatMapInfo.totalPrice > 0 ? (this.showModalAvios = true) : (this.showModalAvios = false);
        this.DatalayerUtils.setRemoveSeatSelectedId();

        const specialNeeds: Array<string> = ['DEAF', 'BLND', 'WCHR', 'WCHS', 'WCHC', 'SVAN'];
        let summaryInfo: any = this.CommonsSessionStorageService.get('summaryInfo');
        let hasSpecialNeeds: boolean = false;
        let italyIsIncluded: boolean = false;
        let issueCountryIsItaly: boolean = false;

        if(summaryInfo === null) {
            summaryInfo = this.CommonsSessionStorageService.get('breakdownInfo');
        }
        if(summaryInfo !== null) {
            if(summaryInfo.context.passengers.length > 1) {
                angular.forEach(summaryInfo.context.passengers, (pass) => {
                    if(pass.passengerType === 'CHILD' || specialNeeds.includes(pass.items[0])) {
                        hasSpecialNeeds = true;
                    }
                });
                if(this.$window.datalayer_general.trayectoPais) {
                    italyIsIncluded = this.$window.datalayer_general.trayectoPais.split('-').some(pais => pais === 'IT');
                    if(!italyIsIncluded) {
                        italyIsIncluded = this.$window.datalayer_general.mercado === 'IT';
                    }
                } else {
                    const flightsInfo = this.CommonsSessionStorageService.get('flightsInfo');
                    if(flightsInfo !== null) {
                        angular.forEach(flightsInfo, (flight)=>{
                            if(flight.arrivalCity.city.country.code === 'IT' || flight.departureCity.city.country.code === 'IT') {
                                italyIsIncluded = true;
                            }
                        });
                    } else {
                        const bookingInfo: any = this.CommonsSessionStorageService.get('bookingInfo');
                        if(bookingInfo) {
                            if(bookingInfo.outwardSegments) {
                                for(let i = 0; i < bookingInfo.outwardSegments.length; i++) {
                                    if(bookingInfo.outwardSegments[i].arrival.airport.country === 'IT' || bookingInfo.outwardSegments[i].departure.airport.country === 'IT') {
                                        italyIsIncluded = true;
                                    }
                                }
                            }
                        }
                    }
                    const ancillariesSummary: any = this.localStorageService.get('breakdownInfo');
                    if(ancillariesSummary) {
                        if(ancillariesSummary.context.issueCountry === 'IT') {
                            issueCountryIsItaly = true;
                        }
                    } else {
                        const ancillariesSummaryCKI: any = this.localStorageService.get('summaryInfo');
                        if(ancillariesSummaryCKI) {
                            if(ancillariesSummaryCKI.context.issueCountry === 'IT') {
                                issueCountryIsItaly = true;
                            }
                        }
                    }
                }
                if((italyIsIncluded || issueCountryIsItaly) && hasSpecialNeeds) {
                    this.model.reductedMovilityBanner = true;
                }
            }
        }
        this.updateDataLayerAndDigitalData(true);
    };

    /**
     * This functions update datalayerInfo. The quadrigam change according to flow.
     * @param {String} quadrigam value to update datalayer_general.
     * @returns {Void}
     *  */
    updateDalayerInfo = (quadrigam): void => {
        const confirmationDatalayerInfo = this.localStorageService.get('confirmationDatalayerInfo');
        const confirmationDigitalInfo = this.localStorageService.get('confirmationDigitalInfo') || {};
        /* INIT DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(
            quadrigam,
            confirmationDatalayerInfo,
            this.AncillariesUtilsService.isUserLogged()
        );
        /* FINISH DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(
            quadrigam,
            confirmationDigitalInfo,
            this.AncillariesUtilsService.isUserLogged()
        );
        this.DatalayerUtilsService.sendDatalayerEvent('view');
        this.$rootScope.$broadcast('updateDatalayer');
    };

    /**
     * Check if have pending seats for show modal
     */
    showCancelModalEarly = (): any => {
        let isPending = false;
        angular.forEach(this.localStorageService.get('addEarlyChecking'), (pass) => {
            if (pass.row === '' || pass.column === '') {
                isPending = true;
            }
        });
        return isPending;
    };

    /**
     * Check if any passenger not have seat
     */
    checkPendingConfirmSeats = (): any => {
        let isEqual = false,
            i;
        for (i = 0; i < this.model.seatMapInfo.passengersInfo.length; i++) {
            if (
                this.model.seatMapInfo.passengersInfo[i].initialSeat.row !==
                    this.model.seatMapInfo.passengersInfo[i].currentSeat.row ||
                this.model.seatMapInfo.passengersInfo[i].initialSeat.column !==
                    this.model.seatMapInfo.passengersInfo[i].currentSeat.column
            ) {
                isEqual = true;
            }
        }
        return isEqual;
    };

    updateDataLayerAndDigitalData = (mapIsOpening: boolean = false): void => {
        const flow = this.localStorageService.get('flowApp');
        let quadrigam = '';
        switch (flow) {
                case this.AncillariesConstants.APPLICATION_FLOW.BBOOKING:
                case this.AncillariesConstants.APPLICATION_FLOW.BOOKING:
                    quadrigam = this.CommonsConstants.STEP_FLOW.ANCILLARIES.toUpperCase();
                    break;
                case this.AncillariesConstants.APPLICATION_FLOW.CHECKIN:
                    quadrigam = this.AncillariesConstants.QUADRIGAM.ANCILLARIES;
                    break;
        }
        if (mapIsOpening) {
            quadrigam = this.AncillariesConstants.QUADRIGAM.MODAL_SELECT_SEAT;
        }
        /* INIT DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES, quadrigam);
        this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
        /* FINISH DELETE GA4 MIGRATION*/
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.updateDatalayerViewEvent();
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updateDigitalData');
        this.$rootScope.$broadcast('sendUpdateToMonetate');
    };

    /**
     *  Exit of seat map and prevoius check conditions:
     *  1 - Early flow
     *     - Is obligatory and it´s necessary select a set for continue flow
     *     - Check if all passenger have a seat and we show modal window for advise user it´s necessary select seat for all passengers
     *  2- In flows different of early if user change the seat and try close the seat map we show the confirmation modal for advise the user
     *
     */
    cancelSeatMap = (): any => {
        const flow = this.localStorageService.get('flowApp');
        this.localStorageService.remove('genAviosAncillariesSeat');
        if (this.AncillariesUtilsService.isCheckinFlow()) {
            if (this.showCancelModalEarly()) {
                this.ModalServiceAncillaries.openModalWarningSeatMap(
                    'ib-modal-close-warning-seats-map',
                    'ib-modals ib-modals--sm',
                    ''
                ).result.then(angular.noop, this.goToInitFlow);
            } else if (this.checkPendingConfirmSeats()) {
                this.ModalServiceAncillaries.openModalWarningSeatMap(
                    'ib-modal-map-seats-cancel',
                    'ib-modals ib-modals--sm',
                    ''
                ).result.then(angular.noop, this.dismissModal);
            } else {
                this.dismissModal();
                this.$rootScope.$broadcast('updateDatalayer');
                this.$rootScope.$broadcast('updatePageType');
            }
        } else {
            if (this.checkPendingConfirmSeats()) {
                this.ModalServiceAncillaries.openModalWarningSeatMap(
                    'ib-modal-map-seats-cancel',
                    'ib-modals ib-modals--sm',
                    ''
                ).result.then(angular.noop, this.dismissModal);
            } else {
                this.dismissModal();
                this.$rootScope.$broadcast('updateDatalayer');
                this.$rootScope.$broadcast('updatePageType');
            }
        }
        if(flow !== this.AncillariesConstants.APPLICATION_FLOW.MMB) {
            this.updateDataLayerAndDigitalData();
        }
    };

    /**
     * Dismiss seat map modal
     */
    dismissModal = (): void => {
        angular.element(this.$window).unbind('click');
        this.$uibModalInstance.dismiss();
    };

    /**
     * Close seat map modal window
     */
    closeSeatMapModal = (): void => {
        this.$uibModalInstance.close();
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
    };

    /**
     * Go to the next passenger in seatmap
     */
    nextPassenger = (): void => {
        this.model.seatMapInfo.currentPassengerIndex =
            this.model.seatMapInfo.currentPassengerIndex + 1 < this.model.seatMapInfo.passengersInfo.length
                ? this.model.seatMapInfo.currentPassengerIndex + 1
                : 0;
        this.changePassenger(this.model.seatMapInfo.currentPassengerIndex);
    };

    /**
     * Go to the previous passenger in seatmap
     */
    previousPassenger = (): void => {
        this.model.seatMapInfo.currentPassengerIndex =
            this.model.seatMapInfo.currentPassengerIndex - 1 < 0
                ? this.model.seatMapInfo.passengersInfo.length - 1
                : this.model.seatMapInfo.currentPassengerIndex - 1;
        this.changePassenger(this.model.seatMapInfo.currentPassengerIndex);
    };

    /**
     * Scroll to passenger when is selected in scroll list component
     * @param {*} evt
     * @param {*} idPassenger
     */
    selectScrollPassenger = (evt, idPassenger): void => {
        let i;
        for (i = 0; i < this.model.seatMapInfo.passengersInfo.length; i++) {
            if (this.model.seatMapInfo.passengersInfo[i].id === idPassenger) {
                this.model.seatMapInfo.currentPassengerIndex = i;
            }
        }
        this.changePassenger(idPassenger);
    };

    /**
     * Change passenger seat and update info of seats updated
     * @param {*} event
     * @param {Object} seatData Information of seat selected to update
     */
    updatePassengerSeat = (event, seatData): void => {
        let i = 0,
            found = false;
        const backInitial = !(this.getInitialPassengerSeat() !== this.getCurrentPassengerSeat());
        while (!found && i < this.updateData.length) {
            if (this.updateData[i].id === seatData.id) {
                found = true;
                if (!backInitial) {
                    angular.copy(seatData, this.updateData[i]);
                } else {
                    this.updateData.splice(i, 1);
                }
            }
            i++;
        }
        if (!found && !backInitial) {
            this.updateData.push(seatData);
        }
        // aqui es donde se actuliza el seatData
        this.seatChange(seatData);
        // aqui generamos el transformer del asiento
        this.model.seatGeneralInfo = this.SeatsMapTransformer.genAviosSeatReq(this.model.seatGeneralInfo, seatData, this.model.seatMapInfo.segmentInfo.id);
        this.localStorageService.set(
            'genAviosAncillariesSeat',
            this.SeatsMapTransformer.genAviosSeatReq(this.model.seatGeneralInfo, seatData, this.model.seatMapInfo.segmentInfo.id)
        );

        this.DatalayerUtils.setSeatSelectItem(this.model, seatData);
        // show modal avios
        this.model.seatMapInfo.totalPrice ? (this.showModalAvios = true) : (this.showModalAvios = false);
        if(this.showTour) {
            this.$window.SeatMapVr.selectScene({
                layout: this.model.orderData.order.slices[0].segments[0].flight.aircraft.code,
                scene: seatData.seat.row + seatData.seat.column,
                thumbnailMode: true,
                mode : 0
            });
        }
    };

    /**
     * Return total price of all seats selected
     * @param {Object} evt Event
     * @param {Object} seat Seat information
     */
    seatChange = (seat): void => {
        this.model.seatMapInfo.totalPrice = 0;
        angular.forEach(this.model.seatMapInfo.passengersInfo, (pas) => {
            if (pas.initialSeat.row !== pas.currentSeat.row || pas.initialSeat.column !== pas.currentSeat.column) {
                this.model.seatMapInfo.totalPrice += pas.seatPrice;
            }
        });
        this.model.seatMapInfo.totalPrice = this.CurrencyService.formatPrice(
            this.model.seatMapInfo.currency,
            this.model.seatMapInfo.totalPrice,
            true,
            false,
            false
        );
    };

    /**
     * Return the initial seat of passenger in text
     */
    getInitialPassengerSeat = (): any => {
        return this.model.seatMapInfo.passengersInfo && this.model.seatMapInfo.passengersInfo.length > 0
            ? this.model.seatMapInfo.passengersInfo[this.model.seatMapInfo.currentPassengerIndex].initialSeat.row +
                  this.model.seatMapInfo.passengersInfo[this.model.seatMapInfo.currentPassengerIndex].initialSeat.column
            : '';
    };

    /**
     * Return the current seat of passenger in text
     */
    getCurrentPassengerSeat = (): any => {
        return this.model.seatMapInfo.passengersInfo && this.model.seatMapInfo.passengersInfo.length > 0
            ? this.model.seatMapInfo.passengersInfo[this.model.seatMapInfo.currentPassengerIndex].currentSeat.row +
                  this.model.seatMapInfo.passengersInfo[this.model.seatMapInfo.currentPassengerIndex].currentSeat.column
            : '';
    };

    /**
     * Update map for show current passenger in seat
     * Check if the next passenger have seat for scroll to that,if not have seat then not make scroll and stay
     * in same position of seat map
     * @param {Integer} idPassenger Id of passenger
     */
    changePassenger = (idPassenger): void => {
        const checkSeatNextPassenger = (): any => {
            return (
                this.model.seatMapInfo.passengersInfo[this.model.seatMapInfo.currentPassengerIndex].currentSeat
                    .column !== '' &&
                this.model.seatMapInfo.passengersInfo[this.model.seatMapInfo.currentPassengerIndex].currentSeat.row !==
                    ''
            );
        };
        for (let i = 0; i < this.model.seatMapInfo.passengersInfo.length; i++) {
            const cabinIndex = this.model.seatMapInfo.passengersInfo[i].currentSeat.cabinIndex;
            const rowIndex = this.model.seatMapInfo.passengersInfo[i].currentSeat.rowIndex;
            const columnIndex = this.model.seatMapInfo.passengersInfo[i].currentSeat.columnIndex;
            if (
                this.model.seatMapInfo.passengersInfo[i].currentSeat.row !== '' &&
                this.model.seatMapInfo.passengersInfo[i].currentSeat.column !== ''
            ) {
                this.model.seatMapInfo.flightMap.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].occupation =
                    this.model.seatMapInfo.passengersInfo[i].id === idPassenger
                        ? this.AncillariesConstants.SEAT_OCCUPATIONS.selection
                        : this.AncillariesConstants.SEAT_OCCUPATIONS.occupiedOtherUser;
            }
        }
        if (checkSeatNextPassenger()) {
            this.$timeout(() => {
                this.$scope.$broadcast('scrollToSeat');
            });
        }
    };

    /**
     * Load previous flight
     */
    previousFlight = (): void => {
        const availableSegments: any = this.localStorageService.get('ancillariesAvailableSegments');
        const actualSegmenId: any = this.localStorageService.get('seatMapSegment');
        const indexSegment = availableSegments.indexOf(actualSegmenId.segmentId.toString()) - 1;
        this.setSegmentInfo(availableSegments[indexSegment]);
        this.isLoading = true;
        this.activate();
    };

    /**
     * Load next flight map
     * Check-in - [Check if is last segment and load the next seat map or close modal]
     * Booking - []
     */

    /**
     * Load back flight map
     */
    backPassenger = (): void => {
        const nextSegment = null,
            isLastSegment = false;
        this.backPassengerUpdate = true;
        this.model.seatMapInfo.currentPassengerIndex--;
        this.updateSeatMap(isLastSegment, nextSegment);
    };

    nextFlight = (): void => {
        const segmentSeat: any = this.localStorageService.get('seatsAvailableSegments');
        let availableSegments: any = this.localStorageService.get('ancillariesAvailableSegments');
        const actualSegmenId: any = this.localStorageService.get('seatMapSegment');
        let i = 0,
            isFound = false,
            nextSegment = null,
            isLastSegment = false;
        this.backPassengerUpdate = false;
        this.model.isLoaded = true;
        this.isLoading = true;
        availableSegments = segmentSeat ? segmentSeat : availableSegments;
        while (!isFound && i < availableSegments.length) {
            if (actualSegmenId.segmentId.toString() === availableSegments[i].toString()) {
                isFound = true;
                if (i + 1 === availableSegments.length) {
                    isLastSegment = true;
                    this.model.isLoaded = false;
                }
            }
            !isLastSegment ? (nextSegment = availableSegments[i + 1]) : angular.noop;
            i++;
        }
        this.updateSeatMap(isLastSegment, nextSegment);
    };

    /**
     * Check-in [If it´s early check-in and all passengers don´t have seats, show modal]
     * Booking []
     * @param {boolean} isLastSegment True if is the last segment of segments selected
     * @param {Object} nextSegment Information of next segment to load
     */
    updateSeatMap = (isLastSegment: any, nextSegment: any): void => {
        const continueFlow = (): void => {
            if (!isLastSegment) {
                this.setSegmentInfo(nextSegment);
                this.activate();
            } else {
                this.DatalayerUtilsService.updateDatalayerActionForAncillaries(
                    'confirmar asiento',
                    'clic',
                    'confirmar'
                );
                this.$rootScope.$broadcast('updateDatalayer');
                this.$rootScope.$broadcast('sendUpdateToMonetate');
                const seats = this.localStorageService.get('genAviosAncillariesSeat');
                this.AncillariesService.getAviosAncillariesSummaryReq(
                    seats,
                    this.AncillariesConstants.TYPE_ANCILLARIE.SEAT
                );
                this.localStorageService.set('genAviosAncillariesSeat', []);
                this.closeSeatMapModal();
            }
        };

        const callSeatMapUpdate = (): void => {
            const i = 0;
            const segment: any = this.localStorageService.get('seatMapSegment');
            this.SeatsMapService.updatePassengersSeats(this.updateData, this.currency).then(() => {
                if (this.updateData.length > 0) {
                    this.SeatsMapTransformer.updateSeatInformation(this.updateData);
                    this.$rootScope.$broadcast('updateHeaderSeats', {
                        segmentId: segment.segmentId,
                        passengers: this.updateData,
                        passengersInfo: this.model.seatMapInfo.passengersInfo
                    });
                }
                continueFlow();
            }, this.updateSeatMapError);
        };

        if (this.isLastPassenger()) {
            if (this.AncillariesUtilsService.isCheckinFlow()) {
                if (this.showUpdateModalEarly()) {
                    this.isLoading = false;
                    this.ModalServiceAncillaries.openSeatMapWarningModal(
                        'ib-modal-close-warning-seats-map',
                        'ib-modals ib-modals--sm'
                    ).result.then(angular.noop, this.goToInitFlow);
                } else {
                    callSeatMapUpdate();
                }
            } else {
                callSeatMapUpdate();
            }
        } else {
            this.isLoading = false;
            if (!this.backPassengerUpdate) {
                this.model.seatMapInfo.currentPassengerIndex++;
            }
            this.changePassenger(
                this.model.seatMapInfo.passengersInfo[this.model.seatMapInfo.currentPassengerIndex].id
            );
            if (
                (this.AncillariesUtilsService.isResolutionToMobile() && this.AncillariesUtilsService.isTouchDevice()) ||
                (this.model.seatMapInfo.currentPassengerIndex + 1 < this.model.seatMapInfo.passengersInfo.length &&
                    this.model.seatMapInfo.currentPassengerIndex > 1)
            ) {
                this.$scope.$broadcast('nextPassengerScroll');
            }
        }
    };

    /**
     * Show error modal with error returned for service
     * @param {Object} errorUpdate
     */
    updateSeatMapError = (errorUpdate): void => {
        let i,
            j = 0,
            message = '',
            found = false,
            errorPassenger = '';

        const setModalErrorProperties = (error): void => {
            this.ModalServiceAncillaries.isNotWaiting();
            this.ModalServiceAncillaries.setErrorMessage(error.message);
            this.ModalServiceAncillaries.setErrorCode(error.internalErrorCode);
            this.ModalServiceAncillaries.setErrorGetOut(this.localStorageService.get('earlyCheckinCode'));
        };

        if (errorUpdate.errorCode === '409') {
            if (errorUpdate.message !== null) {
                for (i = 0; i < errorUpdate.message.length; i++) {
                    message = message + '\n' + errorUpdate.message[i];
                }
                errorUpdate.message = message;
            }
            while (!found && j < this.model.seatMapInfo.passengersInfo.length) {
                if (this.model.seatMapInfo.passengersInfo[j].id === errorUpdate.passengerId) {
                    found = true;
                    this.model.seatMapInfo.currentPassengerIndex = j;
                    errorPassenger = this.model.seatMapInfo.passengersInfo[j].name;
                    // Revisar por que se estaba llamando sin parámetro
                    //this.changePassenger();
                }
                j++;
            }
            setModalErrorProperties(errorUpdate);
            this.ModalServiceAncillaries.setErrorPassengerSeatsMap(errorPassenger);
            this.ModalServiceAncillaries.openSeatMapErrorUpdateModal(
                errorUpdate,
                'md',
                'ib-vista-modal-error-update-seats-map',
                true
            );
        } else {
            setModalErrorProperties(errorUpdate);
            this.ModalServiceAncillaries.isError(errorUpdate, null, null);
        }
    };

    /**
     * Check if actual passenger is the last of segment
     * @returns BOOL
     */
    isLastPassenger = (): any => {
        return this.model.seatMapInfo.currentPassengerIndex === this.model.seatMapInfo.passengersInfo.length - 1;
    };

    /**
     * Check if one passenge or more not have seat assigned
     * @return BOOL True if one passenger or more not have seat | FALSE if all passengers have seat assigned
     */
    showUpdateModalEarly = (): any => {
        let isPending = false;

        angular.forEach(this.model.seatMapInfo.passengersInfo, (pass) => {
            if (pass.currentSeat.row === '' && pass.currentSeat.column === '') {
                isPending = true;
            }
        });
        return isPending;
    };

    /**
     * Go to ibcose
     */
    goToInitFlow = (): void => {
        this.$location.path(this.AncillariesConstants.PAGES_ROUTES.SEARCH_BOOKING);
    };

    /**
     * Set in localStorage informaton of segment to open seat map
     * @param {Integer} segmentId
     */
    setSegmentInfo = (segmentId): void => {
        if (
            this.AncillariesUtilsService.isCheckinFlow() ||
            this.$rootScope.flowName === this.AncillariesConstants.APPLICATION_FLOW.BOOKING
        ) {
            this.AncillariesUtilsService.setSegmentInfo({
                segmentId: segmentId,
                pasId: this.localStorageService.get('passengersSelected')[0]
            });
        } else {
            this.AncillariesUtilsService.setSegmentInfo({
                segmentId: segmentId,
                pasId: this.localStorageService.get('ancillariesAvailablePassengers')[0]
            });
        }
    };

    /*
    ** open modal avios
    */
    openModalAviosSeatAncillaries = (): void => {
        const modalObject = {aviosAncillariesReq: {}, passenger: {}};
        modalObject.aviosAncillariesReq = this.SeatsMapTransformer.genAviosSeatAncillariesReq(this.localStorageService.get('genAviosAncillariesSeat'));
        modalObject.passenger = this.localStorageService.get('bookingInfo');
        this.ModalServiceAncillaries.openAviosAccumulatedModal(modalObject).result.then(() => {}, () => {});
    };

    /*
    ** open modal seats map legend
    */
    openSeatMapLegend  = (): void => {
        const modalObject = {aviosAncillariesReq: {}, passenger: {}};
        modalObject.aviosAncillariesReq = this.SeatsMapTransformer.genAviosSeatAncillariesReq(this.localStorageService.get('genAviosAncillariesSeat'));
        modalObject.passenger = this.localStorageService.get('bookingInfo');
        this.ModalServiceAncillaries.openSeatNewMapLegendModal(modalObject).result.then(() => {}, () => {});
    };

    /*
    ** open modal seats flights mobile
    */
    openSeatsFlightsMobile  = (): void => {
        this.isSummaryMobile = false;
    };
    /*
    ** open modal seats summary flights mobile
    */
    openSummaryFlightMobile = (): void => {
        this.isSummaryMobile = true;
    };

    // showLeyend = (): void => {
    //     this.keyDown = true;
    // };

    // hideLeyend = (): void => {
    //     this.keyDown = false;
    // };
}



try {
    SeatsMapController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(SeatsMapController.name, SeatsMapController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    SeatsMapController.$inject = controllerInfo.inject;
    mod.controller(SeatsMapController.name, SeatsMapController);
}